"use client";

import { Button } from "@/components/ui/button";
import { useCookieConsent } from "@/hooks/useCookieConsent";
import { getLegalLinks } from "@/constants/legalLinks";
import { useLocale, useTranslations } from "next-intl";

export function CookieConsentBanner() {
  const { consent, loaded, accept, decline } = useCookieConsent();
  const t = useTranslations("cookieConsent");
  const legalLinks = getLegalLinks(useLocale());

  // Don't render if consent already given or still loading
  if (!loaded || consent !== undefined) return null;

  return (
    <section
      data-testid="cookie-banner"
      aria-label={t("ariaLabel")}
      className="fixed z-40 bottom-0 inset-x-0 sm:bottom-4 sm:right-4 sm:left-auto sm:max-w-sm animate-slide-in-from-bottom [animation-delay:3s] [animation-fill-mode:both]"
    >
      <div className="bg-background/95 backdrop-blur-sm border-t sm:border sm:rounded-lg border-border shadow-[0_-8px_30px_rgba(0,0,0,0.25)] sm:shadow-xl pb-[env(safe-area-inset-bottom)] sm:pb-0">
        <div className="px-4 py-3 sm:p-4 flex items-center gap-4 sm:flex-col sm:items-stretch sm:gap-3">
          <p className="text-xs sm:text-sm text-foreground/80 flex-1 min-w-0">
            {t.rich("message", {
              cookieLink: (chunks) => (
                <a
                  href={legalLinks.cookies}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-foreground"
                >
                  {chunks}
                </a>
              ),
              privacyLink: (chunks) => (
                <a
                  href={legalLinks.privacy}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-foreground"
                >
                  {chunks}
                </a>
              ),
            })}
          </p>
          <div className="flex items-center gap-2 sm:gap-3 shrink-0 sm:w-full">
            <Button
              variant="outline"
              size="sm"
              onClick={decline}
              className="sm:flex-1"
            >
              {t("decline")}
            </Button>
            <Button size="sm" onClick={accept} className="sm:flex-1">
              {t("accept")}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
